import { render, staticRenderFns } from "./QuickscanFinish.vue?vue&type=template&id=38d47e6e"
import script from "./QuickscanFinish.vue?vue&type=script&lang=js"
export * from "./QuickscanFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports